export const toCents = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return undefined;
  }

  return Math.round(numericValue * 100);
};

export const hasLineItemAmountTotalMismatch = (lineItems, paymentAmount) => {
  const paymentAmountInCents = toCents(paymentAmount);
  if (paymentAmountInCents === null || paymentAmountInCents === undefined) {
    return false;
  }

  if (!lineItems?.length) {
    return false;
  }

  let lineItemsTotalInCents = 0;

  for (const lineItem of lineItems) {
    const lineItemAmountInCents = toCents(lineItem?.amount);

    if (lineItemAmountInCents === undefined) {
      return true;
    }

    if (lineItemAmountInCents !== null) {
      lineItemsTotalInCents += lineItemAmountInCents;
    }
  }

  return lineItemsTotalInCents !== paymentAmountInCents;
};
